var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'option option-' + _vm.optionNumber},[(_vm.optionText)?_c('div',{staticClass:"option-text"},[(_vm.optionNumber)?_c('span',{staticClass:"option-number"},[_vm._v(_vm._s(_vm.optionNumber))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.optionText))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }